import React from "react";

import { Route, Switch, useRouteMatch } from "react-router-dom";

import AddIntegration from "./AddIntegration";
import EditIntegration from "./EditIntegration";
import Integrations from "./Integrations";

interface Props {}

const IntegrationPage: React.FC<Props> = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/add`} component={AddIntegration} />
      <Route path={`${path}/edit/:integrationId`} component={EditIntegration} />
      <Route exact component={Integrations} />
    </Switch>
  );
};

export default IntegrationPage;
